module.exports = __webpack_public_path__ + "img/banner_UpCultura_utilzator_client_vn_190.5a926087.png";